import type { IconData } from '@stacksjs/iconify-core'

export const shareAltF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.928 9.24a4 4 0 0 1-.026 1.644l5.04 2.537a4 4 0 1 1-.867 1.803l-5.09-2.562a4 4 0 1 1 .083-5.228l5.036-2.522a4 4 0 1 1 .929 1.772z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shareAltF
